import { render } from "./ApplicationDetail.vue?vue&type=template&id=6a8dd196&scoped=true"
import script from "./ApplicationDetail.vue?vue&type=script&lang=js"
export * from "./ApplicationDetail.vue?vue&type=script&lang=js"

import "./ApplicationDetail.vue?vue&type=style&index=0&id=6a8dd196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8dd196"]])

export default __exports__